import React from "react";

export default function PaymentComplete() {
  return (
    <div>
      <p>Payment Complete!</p>
    </div>
  );
}
